interface UserAvatarProps {
  user: { firstName: string; lastName: string; email?: string } | null | undefined;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

const SIZE_CLASSES: Record<NonNullable<UserAvatarProps['size']>, { wrap: string; text: string }> = {
  xs: { wrap: 'h-5 w-5', text: 'text-[9px]' },
  sm: { wrap: 'h-6 w-6', text: 'text-[10px]' },
  md: { wrap: 'h-8 w-8', text: 'text-xs' },
};

export function UserAvatar({ user, size = 'sm', className = '' }: UserAvatarProps) {
  const sizeCls = SIZE_CLASSES[size];

  if (!user) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-400 font-medium ${sizeCls.wrap} ${sizeCls.text} ${className}`}
        title="Nicht zugewiesen"
      >
        –
      </span>
    );
  }

  const initials = `${user.firstName[0] ?? ''}${user.lastName[0] ?? ''}`.toUpperCase();
  const fullName = `${user.firstName} ${user.lastName}`;

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-medium ${sizeCls.wrap} ${sizeCls.text} ${className}`}
      title={fullName}
    >
      {initials}
    </span>
  );
}
